import types from './types';

const defaultState = {
  equipmentList: [],
  isLoading: false,
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST:
    case types.GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST:
    case types.GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST:
      return { ...state, isLoading: true };
    case types.GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST_SUCCESS:
      return { ...state, equipmentAssetList: data, isLoading: false };

    case types.GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST_SUCCESS:
      return { ...state, equipmentPositionList: data, isLoading: false };

    case types.GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST_SUCCESS:
      return { ...state, equipmentLevList: data, isLoading: false };
    case types.GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST_FAILURE:
    case types.GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST:
    case types.GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
